export { default } from './menutrigger'
